<template>
    <div>

        <el-row class="bottom20">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="realname" label="姓名">
                    <template slot="header" slot-scope="scope">
                        姓名<br>
                    </template>
                </el-table-column>
                <el-table-column prop="titleLevel" label="职级">
                    <template slot="header" slot-scope="scope">
                        职级<br>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="总分">
                    <template slot="header" slot-scope="scope">
                        总分<br>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination align="right" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-row>

    </div>
</template>

<script type="text/javascript">

    import { mapState, mapGetters, mapMutations, mapActions, createNamespacedHelpers } from 'vuex';
    import AthubCloudApi from '@/api/athubCloud';

    const kpiNSHelper = createNamespacedHelpers( "kpi" );

    const kpiResultHelper = createNamespacedHelpers("kpiResult");

    let that;

    export default {

        name: "KpiResultTable",

        props: {},

        data() {
            return {

                //表格翻页查询条件
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],
                total: 0,
                tableData: [],

                searchParams: {},
                kpiPersonList: [],
                leavePersonList: [],

            }
        },

        methods: {

            ...kpiNSHelper.mapActions([
                'getKpiPersonList',
                'getLeavePersonList',
            ]),

            ...kpiResultHelper.mapActions([
                'getKpiResultPageInfo'
            ]),

            async queryTable() {
                let pageParams = {
                    'currentPage': this.currentPage,
                    'pageSize': this.pageSize,
                }

                let deptInfo = await AthubCloudApi.fetchDeptListByAuthSites();
                let deptIds = deptInfo.map(e => e.id);

                this.searchParams.kpiPersonList = this.kpiPersonList;
                this.searchParams.leavePersonList = this.leavePersonList;
                let params = {...this.searchParams, ...pageParams};
                params.kpiDto.depts = deptIds;

                await this.getKpiResultPageInfo(params);
            },

            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
            },

        },

        watch: {

            kpiInfo: {
                immediate: true,
                deep: true,
                handler: function (newVal, oldVal) {
                    this.searchParams = {
                        kpiDto: {
                            kpino: newVal.kpino,
                            deptid: newVal.deptid,
                            status: newVal.status,
                            kpidate: newVal.kpidate,
                        }
                    };
                    this.currentPage = 1;
                    this.total = 0;
                    this.tableData = [];

                    let params = {'department': newVal.deptid, 'kpidate': newVal.kpidate};
                    let promise1 = this.getKpiPersonList(params).then((res) => {
                        this.kpiPersonList = res;
                    });
                    let promise2 = this.getLeavePersonList(params).then((res) => {
                        this.leavePersonList = res;
                    });
                    Promise.all([promise1, promise2]).then(() => {
                        that.queryTable();
                    });
                }
            },

            pageSize: {
                handler() {
                    this.queryTable();
                },
            },

            currentPage: {
                handler() {
                    this.queryTable();
                },
            },

            kpiResultPageInfo: {
                handler: function (newVal, oldVal) {
                    this.tableData = newVal.tableData;
                    this.total = newVal.total;
                }
            }

        },

        computed: {
            ...mapGetters({
                kpiInfo: ['kpi/kpiInfo'],
                kpiResultPageInfo: ['kpiResult/kpiResultPageInfo'],
            }),
        },

        created() {
            that = this;
        }
    }

</script>